import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function About() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Home
        </button>

        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">About BooksForUs</h1>
            <p className="text-lg text-gray-600">
              Making book clubs simple, fun, and engaging.
            </p>
          </div>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">The Story</h2>
            <p className="text-gray-700 leading-relaxed">
              BooksForUs was built to make good books easier to find and book clubs easier to run.
              Figuring out what to read next, forgotten voting deadlines, wondering what book you read three months ago,
              or forgetting who is up next to pick a book can be problems of the past.
            </p>
            <br />
            <p className="text-gray-700 leading-relaxed">
              This is a passion project built with a love for reading and a healthy disregard for convention.
            </p>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
              <svg className="w-6 h-6 mr-2 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.5 3h-17A1.5 1.5 0 002 4.5v15A1.5 1.5 0 003.5 21h17a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0020.5 3zM8 17v-5.5c0-.828.672-1.5 1.5-1.5h5c.828 0 1.5.672 1.5 1.5V17M10 7h.01M14 7h.01" />
              </svg>
              Support This Project
            </h2>
            <p className="text-gray-700 mb-6">
              BooksForUs is free to use. If you find it useful and want to support
              continued development, you can buy me a coffee. It helps keep the servers running and
              motivates me to keep building features that make book clubs better.
            </p>
            <a
              href="https://buymeacoffee.com/amburke"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-lg transition-colors shadow-sm"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.5 3h-17A1.5 1.5 0 002 4.5v15A1.5 1.5 0 003.5 21h17a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0020.5 3zM8 17v-5.5c0-.828.672-1.5 1.5-1.5h5c.828 0 1.5.672 1.5 1.5V17M10 7h.01M14 7h.01" />
              </svg>
              Buy Me a Coffee
            </a>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3 flex items-center">
              <svg className="w-6 h-6 mr-2 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
              Thank You
            </h2>
            <p className="text-gray-700">
              To everyone using BooksForUs: thank you for being part of this journey. Your feedback,
              bug reports, and feature requests make this better every day. Happy reading!
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
